<template>
  <el-menu default-active="1-1">
    <el-submenu index="1">
      <template slot="title">
        <i class="el-icon-location"></i>
        <span>{{ $t("my_chats") }}</span>
      </template>
      <el-menu-item v-for="chat in privateChats" :key='chat.id' index="1-1" @click="openChat(chat.id, chat.label)">
        <div>{{ chat.label }}</div>
      </el-menu-item>
    </el-submenu>
  </el-menu>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters({
      myChats: 'myChats',
      activeChat: 'activeChat',
      privateChats: 'privateChats',
      newMessagesPerRoom: 'newMessagesPerRoom'
    })
  },
  methods: {
    openChat (id, label) {
      this.$emit('viewRoom')
      this.$store.dispatch('GET_CHATROOM', {id: id, page: 1, perPage: 10})
    }
  }
}
</script>

<style lang="scss">
// .box-card {
//   width: 280px;
// }
li.el-menu-item.list-group-item {
  padding-left: 5px;
}
.el-submenu {
  border-radius: 20px;
  overflow-wrap: break-word;
  border: 2px solid #7fa3bb;
  padding: 5px;
  &__title:hover {
    background-color: "#b3c0d1";
  }
}
.el-menu-vertical-admin {
  margin: 5px;
  word-wrap: break-word;
  border-radius: 0px 20px;
  border: 2px solid #7fa3bb;
  padding: 10px;
}
.el-card__body {
  padding: 2px;
  // height: 40px;
}
/*.el-input--small .el-input__inner {*/
  /*width: 150px*/
/*}*/
// .el-card {
//   margin: 5px;
// }
.el-card__header {
  padding: 8px 20px;
}
.list-group-item {
  background-color: #7fa3bb;
  &:hover {
    background-color: #4d7590;
  }
  position: relative;
  display: block;
  margin-bottom: 0px;
  border: 1px solid rgba(0,0,0,.125);
  border-radius: 4px
}
.list-group {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
}
ul, menu, dir {
  display: block;
  list-style-type: disc;
  -webkit-margin-after: 1em;
  -webkit-margin-start: 0px;
  -webkit-margin-end: 0px;
}
</style>
